import { useState } from "react";
import API from "../../services/api";
import { toast } from "react-toastify";

export default function ImportModal({ modalRef, fileInputRef, onImport, uploadProgress, uploading }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [templateLoading, setTemplateLoading] = useState(false);

  const handleDownloadTemplate = async () => {
    setTemplateLoading(true);
    try {
      const res = await API.get("/leads/template", {
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "template_leads.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTemplateLoading(false);
    } catch (err) {
      setTemplateLoading(false);
      toast.error("Gagal download template.");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleSubmitImport = () => {
    if (!selectedFile) {
      toast.info("Silakan pilih file terlebih dahulu.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    onImport(formData);
  };

  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
      <div className="modal-dialog modal-import-lead">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Import Data Leads</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <button
              className="btn btn-outline-secondary ms-2 mb-3"
              onClick={handleDownloadTemplate}
              disabled={templateLoading}
            >
              {templateLoading ? (
                "Download..."
              ) : (
                <>
                  <i className="fa-solid fa-download"></i> Download Template
                </>
              )}
            </button>
            {uploading && (
              <div className="mb-3">
                <label className="form-label">
                  Uploading... {uploadProgress}%
                </label>
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${uploadProgress}%` }}
                    aria-valuenow={uploadProgress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {uploadProgress}%
                  </div>
                </div>
              </div>
            )}

            <div className="mb-3">
              <label htmlFor="excelFile" className="form-label fw-semibold">
                Upload File Excel
              </label>
              <input
                type="file"
                id="excelFile"
                ref={fileInputRef}
                accept=".xlsx,.xls"
                className="form-control"
                onChange={handleFileChange}
              />
              <div className="form-text">Format yang didukung: .xls, .xlsx</div>
            </div>

            <button
              className="btn btn-primary"
              onClick={handleSubmitImport}
              disabled={!selectedFile || uploading}
            >
              {uploading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Mengupload...
                </>
              ) : (
                <>
                  <i className="fa-solid fa-file-import"></i> Simpan
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
